module.exports = __webpack_public_path__ + "img/hydrologiskpalegg.0841e29b.jpg";